<template>
	<div class="title-container">
		<h2
			class="title"
			:style="{ fontSize: applyCustomStyle ? '22px' : '24px' }"
		>
			Related Posts
		</h2>
		<NuxtLink
			class="blogs-and-insights"
			:style="{ fontSize: applyCustomStyle ? '16px' : '18px' }"
			to="/category/bohens-take/"
		>
			More From Bohen
		</NuxtLink>
	</div>
	<div class="post-thumbnails-container">
		<div class="post-item-container">
			<NuxtLink
				v-for="(post, index) in shuffleArray(posts).slice(0, 3)"
				:key="index"
				class="post-item"
				:to="`/${post.slug}/`"
			>
				<RelatedPostImage
					:source-url="post.featured_media.source_url"
					:slug="post.slug"
					class="post-thumbnail"
				/>
				<div class="post-info-container">
					<span
						class="post-title"
						v-html="post.title.rendered"
					></span>
					<div class="post-info-date-and-time">
						<span class="post-date">
							{{ dateFormat(post.modified_gmt, false, true) }}
						</span>
						<span class="post-time">
							{{ post.yoast_head_json.twitter_misc["Est. reading time"] }}
						</span>
					</div>
				</div>
			</NuxtLink>
		</div>
	</div>
</template>
<script setup>
import { ref } from "vue";

const props = defineProps(["posts", "applyCustomStyle"]);

const posts = ref(props.posts);

watch(
	() => props.posts,
	(newPosts) => {
		posts.value = newPosts;
	}
);
</script>

<style lang="scss" scoped>
@use "~/assets/utils.scss" as *;

.title-container {
	padding-bottom: 24px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 12px;
	@include breakpoint(lg) {
		padding-bottom: 36px;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
}

.title {
	color: #0d0d12;
	font-family: Open Sauce Sans;
	font-size: 24px;
	font-style: normal;
	font-weight: 500;
	line-height: 120%; /* 28.8px */
	letter-spacing: -2px;
}

.blogs-and-insights {
	color: #4383ff;
	text-align: center;
	font-family: DM Sans;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 144.444% */

	&::after {
		content: "";
		display: inline-block;
		width: 28px;
		height: 28px;
		background-color: #4a8fff;
		background-image: url("/images/arrow-right.svg");
		background-repeat: no-repeat;
		background-size: 18px;
		background-position: center;
		border-radius: 50%;
		margin-left: 8px;
		vertical-align: middle;
	}
}

.post-thumbnails-container {
	display: flex;
	align-items: center;
}

.post-item {
	display: flex;
	justify-content: flex-start;
	margin-bottom: 24px;

	span {
		padding-bottom: 8px;
	}

	.post-item:last-child {
		margin-bottom: 0;
	}

	@include breakpoint(lg) {
	}
}

.post-thumbnail-container {
	margin-right: 16px;
}

.post-thumbnail {
	:deep(img) {
		border-radius: 8px;
		max-width: 138px;
		max-height: 100px;

		@include breakpoint(md) {
			width: 138px;
			height: 100px;
		}
	}
}

.post-title {
	color: #0d0d12;
	font-family: DM Sans;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 24px; /* 133.333% */
	display: flex;
}

.post-info-date-and-time {
	span {
		overflow: hidden;
		color: #666d80;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-family: DM Sans;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 1;
		margin-bottom: 0;
	}

	.post-date {
		&::after {
			content: "|";
			margin: 0 4px;
			color: #666d80;
			font-family: DM Sans;
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 1;
		}
	}
	.post-time {
		padding-left: 0;
	}
}
</style>
